const mobileBestsellersCarousel = () => ({
  swiper: null,
  autoScrollEnabled: false,
  autoScrollDelay: 2000,
  autoScrollTimer: null,
  isUserInteracting: false,
  
  init() {
    // Read settings from data attributes
    this.autoScrollEnabled = this.$el.dataset.autoScroll === 'true';
    this.autoScrollDelay = parseInt(this.$el.dataset.autoScrollDelay) || 2000;
    
    this.initSwiper();
    this.setupVisibilityObserver();
  },
  
  initSwiper() {
    const swiperContainer = this.$el.querySelector('[data-swiper-bestsellers]');
    if (!swiperContainer) return;
    
    // Dynamic import for Swiper (assuming it's available globally)
    if (typeof Swiper !== 'undefined') {
      this.createSwiper();
    } else {
      // Fallback: load Swiper if not available
      const script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
      script.onload = () => this.createSwiper();
      document.head.appendChild(script);
    }
  },
  
  createSwiper() {
    this.swiper = new Swiper('[data-swiper-bestsellers]', {
      slidesPerView: '3.98',
      slidesOffsetBefore: 20,
      slidesOffsetAfter: 20,
      spaceBetween: 8,
      freeMode: false,
      grabCursor: true,
      loop: false,
      scrollbar: {
        el: '.swiper-scrollbar',
        hide: false,
        draggable: true,
      },
      // Event callbacks for manual override
      on: {
        init: () => {
          // Start auto-scroll after swiper is fully initialized, but only if menu is visible
          this.checkVisibilityAndStartAutoScroll();
        },
        touchStart: () => {
          this.pauseAutoScroll();
          this.isUserInteracting = true;
        },
        touchEnd: () => {
          this.isUserInteracting = false;
          // Resume auto-scroll immediately after user stops interacting
          this.resumeAutoScroll();
        },
        slideChange: () => {
          // Reset timer when slide changes
          if (this.autoScrollEnabled && !this.isUserInteracting) {
            this.resetAutoScrollTimer();
          }
        }
      }
    });
  },
  
  setupAutoScroll() {
    if (!this.autoScrollEnabled) return;
    
    this.startAutoScroll();
  },
  
  checkVisibilityAndStartAutoScroll() {
    const mobileMenuWrapper = document.querySelector('.mobile-menu__wrapper');
    if (mobileMenuWrapper) {
      // Check for positive class (ps-left-0) instead of negative class
      const isVisible = mobileMenuWrapper.classList.contains('ps-left-0');
      if (isVisible && this.autoScrollEnabled) {
        this.setupAutoScroll();
      }
    } else {
      // Fallback if menu wrapper not found
      this.setupAutoScroll();
    }
  },
  
  startAutoScroll() {
    if (!this.swiper || !this.autoScrollEnabled) return;
    
    this.autoScrollTimer = setInterval(() => {
      if (!this.isUserInteracting && this.swiper) {
        this.swiper.slideNext();
      }
    }, this.autoScrollDelay);
  },
  
  pauseAutoScroll() {
    if (this.autoScrollTimer) {
      clearInterval(this.autoScrollTimer);
      this.autoScrollTimer = null;
    }
  },
  
  resumeAutoScroll() {
    if (this.autoScrollEnabled && !this.autoScrollTimer) {
      this.startAutoScroll();
    }
  },
  
  resetAutoScrollTimer() {
    this.pauseAutoScroll();
    this.resumeAutoScroll();
  },
  
  setupVisibilityObserver() {
    // Pause auto-scroll when mobile menu is not visible
    const mobileMenuWrapper = document.querySelector('.mobile-menu__wrapper');
    if (mobileMenuWrapper) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            // Check for positive class (ps-left-0) instead of negative class
            const isVisible = mobileMenuWrapper.classList.contains('ps-left-0');
            
            if (isVisible && this.autoScrollEnabled) {
              // If no timer exists, start auto-scroll, otherwise just resume
              if (!this.autoScrollTimer) {
                this.setupAutoScroll();
              } else {
                this.resumeAutoScroll();
              }
            } else {
              this.pauseAutoScroll();
            }
          }
        });
      });
      
      observer.observe(mobileMenuWrapper, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
    
    // Also handle page visibility
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.pauseAutoScroll();
      } else if (this.autoScrollEnabled) {
        this.resumeAutoScroll();
      }
    });
  },
  
  destroy() {
    this.pauseAutoScroll();
    
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
});

export default mobileBestsellersCarousel; 